import React from 'react';
import { Stack, Typography } from '@mui/material';
import { formatDate } from '@/utils/constants';
import { UserChip } from '@/admin/shared/chips/UserChip';
import { USER_IMPORT_STATUSES, useGetUserImportQuery } from '../../api/userImportsApi';

/** When a user import started and who started it, then when it finished (or stopped). */
export const UserImportReportTimes = ({ importId }) => {
	const { data: userImport } = useGetUserImportQuery(importId);
	const { status, createdBy, createdAt, finishedAt } = userImport;

	return (
		<Stack direction='row' spacing={1} alignItems='center' flexWrap='wrap'>
			<Typography variant='body2' color='text.secondary'>
				{`Started ${formatDate(createdAt, true)} by`}
			</Typography>
			<UserChip id={createdBy} />
			{finishedAt && (
				<Typography variant='body2' color='text.secondary'>
					<span style={{ padding: '0 0.5em' }}>|</span>
					{`${status === USER_IMPORT_STATUSES.failed ? 'Stopped' : 'Finished'} ${formatDate(finishedAt, true)}`}
				</Typography>
			)}
		</Stack>
	);
};
